import { IssueCaseDoc, IssueCaseStatusCode } from '@gooduncles/gu-app-schema';
import { useEffect, useState } from 'react';

import { observeIssueCases } from 'src/utils/firebase/firebase-short-cut';

interface UseRecentIssueCasesOptions {
  limit?: number;
}

export const useRecentIssueCases = (storeId: string | null, options: UseRecentIssueCasesOptions = {}) => {
  const { limit = 10 } = options;
  const [issueCases, setIssueCases] = useState<IssueCaseDoc[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!storeId) {
      setIssueCases([]);
      return;
    }

    setIsLoading(true);

    // status 조건을 쿼리에서 제거하고 클라이언트에서 필터링 (기존 색인 활용)
    const subscription = observeIssueCases(
      [['storeId', '==', storeId]],
      {
        sortKey: 'registeredAt',
        orderBy: 'desc',
        limit: limit * 3, // CLOSED 상태만 필터링하므로 여유있게 가져옴
      }
    ).subscribe({
      next: (cases) => {
        const closedCases = cases
          .filter((c) => c.status === IssueCaseStatusCode.CLOSED)
          .slice(0, limit);
        setIssueCases(closedCases);
        setIsLoading(false);
      },
      error: (err) => {
        console.error('Failed to fetch recent issue cases:', err);
        setIsLoading(false);
      },
    });

    return () => subscription.unsubscribe();
  }, [storeId, limit]);

  return { issueCases, isLoading };
};
